import React from "react";
import { useFormikContext } from "formik";
import { AcmeCoOperationErrorIcon } from "../../assets/icons";

const AdminSetup = () => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    useFormikContext();

  return (
    <div className="space-y-6">
      <div className="bg-[#EDF7FF] rounded-xl sm:p-6 p-3">
        <div className="flex flex-col xl:flex-row md:items-start gap-4 md:justify-between">
          <div className="flex items-center gap-3">
            <span className="min-[40px]">{AcmeCoOperationErrorIcon}</span>
            <div>
              <span className="text-[16px] font-semibold mb-2 block">
                Primary Administrator account
              </span>
              <p className="text-[16px] text-gray-500 text-sm mb-0">
                This will be the main account for the tenant
              </p>
            </div>
          </div>
        </div>
      </div>

      <section className="space-y-6 flex-1">
        <div className="grid gap-6 md:grid-cols-2">
          <div className="form-group">
            <label>
              First Name <span>*</span>
            </label>
            <input
              type="text"
              name="adminFirstName"
              placeholder="Enter First Name"
              value={values.adminFirstName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                errors.adminFirstName && touched.adminFirstName ? "error" : ""
              }
            />
            {errors.adminFirstName && touched.adminFirstName && (
              <div className="error-message">{errors.adminFirstName}</div>
            )}
          </div>

          <div className="form-group">
            <label>
              Last Name <span>*</span>
            </label>
            <input
              type="text"
              name="adminLastName"
              placeholder="Enter Last Name"
              value={values.adminLastName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                errors.adminLastName && touched.adminLastName ? "error" : ""
              }
            />
            {errors.adminLastName && touched.adminLastName && (
              <div className="error-message">{errors.adminLastName}</div>
            )}
          </div>

          <div className="form-group">
            <label>
              Admin Email <span>*</span>
            </label>
            <input
              type="email"
              name="adminEmail"
              placeholder="admin@example.com"
              value={values.adminEmail}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.adminEmail && touched.adminEmail ? "error" : ""}
            />
            {errors.adminEmail && touched.adminEmail && (
              <div className="error-message">{errors.adminEmail}</div>
            )}
          </div>

          <div className="form-group">
            <label>
              Admin Number <span>*</span>
            </label>
            <input
              type="tel"
              name="adminPhone"
              placeholder="+44-736-837"
              value={values.adminPhone}
              onChange={(e) => {
                // Allow only numbers and limit to 10 digits
                const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                setFieldValue("adminPhone", value);
              }}
              onBlur={handleBlur}
              className={errors.adminPhone && touched.adminPhone ? "error" : ""}
            />
            {errors.adminPhone && touched.adminPhone && (
              <div className="error-message">{errors.adminPhone}</div>
            )}
          </div>

          <div className="space-y-4 md:col-span-2">
            <label className="flex items-center gap-3 cursor-pointer select-none">
              <div className="relative !h-5 !w-5">
                <input
                  type="checkbox"
                  name="requirePasswordReset"
                  checked={values.requirePasswordReset}
                  onChange={handleChange}
                  className="peer hidden !p-0"
                />
                <span className="flex h-5 w-5 items-center justify-center rounded-[16px] border-2 border-[#9BA2AB] peer-checked:border-[#4285F4] bg-white peer-checked:bg-white"></span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="hidden h-4 w-4 text-[#4285F4] peer-checked:block absolute top-[90%] left-[90%] -translate-x-1/2 -translate-y-1/2"
                  fill="#4285F4"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="text-[#888076] text-span !leading-[15px] !tracking-[0]">
                Require password reset on first login
              </div>
            </label>

            <label className="flex items-center gap-3 cursor-pointer select-none">
              <div className="relative !h-5 !w-5">
                <input
                  type="checkbox"
                  name="sendWelcomeEmail"
                  checked={values.sendWelcomeEmail}
                  onChange={handleChange}
                  className="peer hidden !p-0"
                />
                <span className="flex h-5 w-5 items-center justify-center rounded-[16px] border-2 border-[#9BA2AB] peer-checked:border-[#4285F4] bg-white peer-checked:bg-white"></span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="hidden h-4 w-4 text-[#4285F4] peer-checked:block absolute top-[90%] left-[90%] -translate-x-1/2 -translate-y-1/2"
                  fill="#4285F4"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="text-[#888076] text-span !leading-[15px] !tracking-[0]">
                Send welcome email
              </div>
            </label>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminSetup;
